import { render, staticRenderFns } from "./SettingUpload.vue?vue&type=template&id=1dadf814&scoped=true"
import script from "./SettingUpload.vue?vue&type=script&lang=js"
export * from "./SettingUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadf814",
  null
  
)

export default component.exports